export default __webpack_public_path__ + "static/media/pictogramBeaconCamera40.6df00144.svg";